import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { gotoLogin } from '@/features/Functions/ResultFunctions';

interface CustomButtonProps {
  label: string; // We now expect the label to be a string
  counter?: number;
  maxCount?: number;
  loading?: boolean;
  premium?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

// Styled button with dynamic background based on counter
const StyledButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'counter' && prop !== 'maxCount' && prop !== 'premium',
})<CustomButtonProps>(({ theme, counter = 5, maxCount = 5, premium }) => {
  const percentage = premium ? 100 : (counter / maxCount) * 100;

  return {
    fontSize: '0.875rem',
    padding: '0.5rem 1rem',
    width: '100%',
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    // background: counter === 0 && !premium
    //   ? '#4CAF50' // Green color when counter is 0
    //   : `linear-gradient(to right,
    //       ${theme.palette.primary.main} ${percentage}%,
    //       ${theme.palette.grey[400]} ${percentage}% 100%)`,
    background: counter === 0 && !premium
      ? '#4CAF50' // Green color when counter is 0
      : undefined,
    transition: 'background 0.3s ease-in-out',
    color: theme.palette.common.white,
    '&:disabled': {
      background: theme.palette.grey[500],
      cursor: 'not-allowed',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
      padding: '0.75rem 1.5rem',
      width: 'auto',
      height: '60px',
    },
  };
});

const CustomButton: React.FC<CustomButtonProps> = ({
                                                     label,
                                                     counter = 5,
                                                     maxCount = 5,
                                                     loading = false,
                                                     disabled = false,
                                                     premium = false,
                                                     onClick,
                                                   }) => {

  // Handle button click
  const handleClick = () => {
    if (counter <= 0 && !premium) {
      disabled = false;
      gotoLogin();
    } else {
      console.log(counter);

      onClick?.(); // Call the original onClick handler
    }
  };

  // Determine the button text based on the counter and premium status
  const getButtonText = () => {
    if (loading) {
      return null; // Loading spinner will be shown
    }
    if (premium) {
      return label; // If premium, just show the label
    }
    if (counter <= 0) {
      return <FormattedMessage id="daily_limit_reached" />; // Show this message when counter is 0
    }
    return `${label} (${counter}/${maxCount})`; // Show counter if not premium and counter > 0
  };

  return (
    <StyledButton
      type="submit"
      variant="contained"
      disabled={loading || disabled} // Disable only if loading or explicitly disabled
      onClick={handleClick} // Use custom click handler
      counter={counter}
      maxCount={maxCount}
      premium={premium}
     label={label}>
      <AutoFixHighIcon />
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        getButtonText() // Render the appropriate button text
      )}
    </StyledButton>
  );
};

export default CustomButton;
